import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCommentFull = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M6.986 3h-.005a4.01 4.01 0 0 0-3.98 4.037v9.286a.677.677 0 0 0 1.008.59l3.154-1.767h5.856A4.01 4.01 0 0 0 17 11.109V7.037A4.01 4.01 0 0 0 13.02 3z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCommentFull;
